import { defineStore } from 'pinia';
import api from '@/plugins/axios';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('admin_token') || null,
    user: JSON.parse(localStorage.getItem('admin_user') || 'null'),
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    isAdmin: (state) =>
      state.user?.roles?.includes('admin') ||
      state.user?.roles?.includes('super_admin'),
    userName: (state) => state.user?.name || 'Admin',
    userPhone: (state) => state.user?.phone || '',
    userRoles: (state) => state.user?.roles || [],
    userPermissions: (state) => state.user?.permissions || [],
    isSuperAdmin: (state) => state.user?.roles?.includes('super_admin') ?? false,
    isFullAdmin: (state) =>
      state.user?.roles?.includes('super_admin') ||
      state.user?.roles?.includes('admin'),
  },

  actions: {
    hasPermission(permission) {
      if (!permission) return true;
      if (this.isFullAdmin) return true;
      const perms = this.userPermissions;
      if (!perms.length) return true;
      return perms.includes(permission);
    },
    setAuth(token, user) {
      this.token = token;
      this.user = user;
      localStorage.setItem('admin_token', token);
      localStorage.setItem('admin_user', JSON.stringify(user));
    },

    async sendOtp(identifier, countryCode = '+967', channel = 'sms') {
      const response = await api.post('/auth/send-otp', {
        identifier,
        channel,
        country_code: countryCode,
      });
      return response.data;
    },

    async verifyOtp(identifier, code, countryCode = '+967') {
      const response = await api.post('/auth/verify-otp', {
        identifier,
        code,
        country_code: countryCode,
      });
      const data = response.data;
      if (data.success || data.data?.token) {
        const payload = data.data || data;
        this.setAuth(payload.token, payload.user);
        await this.fetchMe();
      }
      return data;
    },

    async fetchMe() {
      if (!this.token) return null;
      try {
        const { data } = await api.get('/auth/me');
        const payload = data.data || data;
        if (payload.user) {
          this.user = payload.user;
          localStorage.setItem('admin_user', JSON.stringify(payload.user));
        }
        return payload.user;
      } catch {
        return null;
      }
    },

    async logout() {
      try {
        await api.post('/auth/logout');
      } catch (e) {
        // Ignore errors on logout
      }
      this.token = null;
      this.user = null;
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
    },
  },
});
